import React from 'react';
import { Grid, Paper, Skeleton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useMessages } from 'modules/intl';
import { SummaryHoursLabels } from './utils';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0, 2),
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    width: '34%',
    justifyContent: 'space-between'
  },
  acceptContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1)
  },

  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },

  label: {
    color: theme.palette.text.secondary
  },
  div: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    width: '80%'
  },
  skeleton: {
    backgroundColor: theme.skelton.color,
    width: '100%',
    height: theme.spacing(4.5)
  }
}));

const labels = [
  `insights.summaryHours.${SummaryHoursLabels.scheduled}`,
  `insights.summaryHours.${SummaryHoursLabels.worked}`,
  `insights.summaryHours.${SummaryHoursLabels.remaining}`
];
export const SummarySkeleton: React.FC = () => {
  const classes = useStyles();
  const messages = useMessages(labels);

  return (
    <>
      <Paper
        className={classes.container}
        elevation={3}
        data-testid={'skeleton-container'}
      >
        <Grid flexWrap={'wrap'} className={classes.grid}>
          <div
            className={classes.acceptContainer}
            data-testid={'skeleton-hours-summary-scheduled'}
          >
            <Typography
              variant="body2"
              whiteSpace="nowrap"
              className={classes.label}
            >
              {
                messages[
                  `insights.summaryHours.${SummaryHoursLabels.scheduled}`
                ]
              }
            </Typography>
            <div className={classes.div}>
              <Skeleton
                className={classes.skeleton}
                data-testid="skeleton-box-schedule"
              />
            </div>
          </div>
          <div
            className={classes.acceptContainer}
            data-testid={'skeleton-hours-summary-worked'}
          >
            <Typography
              variant="body2"
              whiteSpace="nowrap"
              className={classes.label}
            >
              {messages[`insights.summaryHours.${SummaryHoursLabels.worked}`]}
            </Typography>
            <div className={classes.div}>
              <Skeleton
                className={classes.skeleton}
                data-testid="skeleton-box-worked"
              />
            </div>
          </div>
          <div
            className={classes.acceptContainer}
            data-testid={'skeleton-hours-summary-remaining'}
          >
            <Typography
              variant="body2"
              whiteSpace="nowrap"
              className={classes.label}
            >
              {
                messages[
                  `insights.summaryHours.${SummaryHoursLabels.remaining}`
                ]
              }
            </Typography>
            <div className={classes.div}>
              <Skeleton
                className={classes.skeleton}
                data-testid="skeleton-box-remaining"
              />
            </div>
          </div>
        </Grid>
      </Paper>
    </>
  );
};
